export default "__VITE_ASSET__zbdxXRYA__"